<template>
	<!-- <div class="tablist_item">
    <div
      class="items"
      :class="[{ active: activeName == item.name }]"
      v-for="item in itemList"
      :key="item.id"
      @click="tabItemClick(item)"
    >
      {{ item.name }}
    </div>
    <p>当前时间：{{ realTime }} </p>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
  </div> -->
	<div class="contents">
		<div class="content_map">
			<div class="tablist_item">
				<div class="items" :class="[{ active: activeName == item.name,hotStyle:item.name == '早稻收获统计', hotStyle2:item.name == '麦收进度管理' }]" v-for="item in itemList" :key="item.id" @click="tabItemClick(item)">
					{{ item.name }}
					<!-- <img class="hot-icon" v-if="item.id==9" src="../../../assets/img/ms/hot.png" alt=""/> -->
				</div>
			</div>
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</keep-alive>
		</div>
	</div>
</template>
<script>
	import Api from "@/Serves/net-api.js";
	import Http from "@/Serves/net-http.js";
	export default {
		components: {},
		data() {
			return {
				activeName: "首页",
				itemList: [{
						id: 0,
						name: "首页"
					},
					{
						id: 1,
						name: "农机分布热力图"
					},
					{
						id: 2,
						name: "各地区农机统计"
					},
					{
						id: 3,
						name: "当日作业农机热力图"
					},
					{
						id: 4,
						name: "农机作业进度"
					},
					{
						id: 5,
						name: "农机作业趋势"
					},
					{
						id: 6,
						name: "农机预警统计"
					},
					{
						id: 7,
						name: "补贴用户作业排行"
					},
					// {
					// 	id: 9,
					// 	flag:9,
					// 	name: "麦收进度管理"
					// },
				],
				machineShow: true,
				mapShow: false,
				areasuperShow: false,
				operationShow: false,
				isWheat: []
			};
		},
		mounted() {
			// this.secondTitle= this.$store.state.areaName === '全国'?'各省补贴机具统计':'各地区农机统计'
			if(window.location.host === 'jiangxi.dtwl360.com') {
				this.itemList = [{
						id: 0,
						name: "首页"
					},
					{
						id: 1,
						name: "农机分布热力图"
					},
					{
						id: 2,
						name: "各地区农机统计"
					},
					{
						id: 3,
						name: "当日作业农机热力图"
					},
					{
						id: 4,
						name: "农机作业进度"
					},
					{
						id: 5,
						name: "农机作业趋势"
					},
					{
						id: 6,
						name: "农机预警统计"
					},
					{
						id: 7,
						name: "补贴用户作业排行"
					},
					{
						id: 8,
						name: "早稻收获统计"
					},
					// {
					// 	id: 9,
					// 	flag:9,
					// 	name: "麦收进度管理"
					// },

				]
			} else if (window.location.host === 'jiangsu.dtwl360.com' || window.location.host === 'localhost:8080') {
        this.itemList.push({
          id: 9,
          flag: 9,
          name: "麦收进度管理"
        })
      }
      // 广东无需麦收进度管理
			// if(window.location.host.indexOf('guangdong')>-1) {
      //   let obj = this.itemList.findIndex((item) => {
      //     if(item.flag == 9) {
      //       return true;
      //     }
      //   })
      //   this.itemList.splice(obj,1)
      // }
			
			// let obj = this.itemList.findIndex((item) => {
			// 	if(item.flag == 9) {
			// 		return true;
			// 	}
			// });
			// if(obj==-1 && this.isWheat.length==0) {
			// 	Api.doPost(Http.test + '/account/userSideMenuList', {}, false, (res) => {
			// 		this.isWheat = res.result.filter((item) => {
			// 			return item.menuPath == "/nj/maishou";
			// 		});
			// 		//根据是否有麦收路由判断是否显示麦收菜单
			// 		//				let obj = this.itemList.findIndex((item) => {
			// 		//					if(item.flag == 9) {
			// 		//						return true;
			// 		//					}
			// 		//				});
			// 		if(this.isWheat.length > 0) {
			// 			this.itemList.push({
			// 				id: 9,
			// 				flag: 9,
			// 				name: "麦收进度管理"
			// 			})
			// 		}
			// 	})
			// }

			// this.itemList[1].name = this.secondTitle
			if(window.location.pathname === "/view/ToolDistributionHeat") {
				this.activeName = "农机分布热力图";
				this.$router.push("/ToolDistributionHeat");
			} else if(window.location.pathname === "/view/ToolStatistics") {
				this.activeName = '各地区农机统计';
				this.$router.push("/ToolStatistics");
			} else if(window.location.pathname === "/view/WorkHeatMap") {
				this.activeName = "当日作业农机热力图";
				this.$router.push("/WorkHeatMap");
			} else if(window.location.pathname === "/view/ToolWorkProgress") {
				this.activeName = "农机作业进度";
				this.$router.push("/ToolWorkProgress");
			} else if(window.location.pathname === "/view/ToolWorkTrend") {
				this.activeName = "农机作业趋势";
				this.$router.push("/ToolWorkTrend");
			} else if(window.location.pathname === "/view/ToolWorkRank") {
				this.activeName = "补贴用户作业排行";
				this.$router.push("/ToolWorkRank");
			} else if(window.location.pathname === "/view/WarningEquipment") {
				this.activeName = "农机预警统计";
				this.$router.push("/WarningEquipment");
			} else if(window.location.pathname === "/view/HarvestStatistics") {
				this.activeName = "早稻收获统计";
				this.$router.push("/HarvestStatistics");
			} else if(window.location.pathname === "/view/WheatHarvest") {
				this.activeName = "麦收进度管理";
				this.$router.push("/WheatHarvest");
			} else {
				this.activeName = "首页";
				this.$router.push("/");
			}

		},
		methods: {
			tabItemClick(item) {
				sessionStorage.removeItem('manageParams1')
				this.$store.commit('toolWorkRankData', [])
				this.activeName = item.name;
				if(item.id === 0) {
					this.$router.push("/");
				} else if(item.id === 1) {
					this.$router.push("/ToolDistributionHeat");
				} else if(item.id === 2) {
					this.$router.push("/ToolStatistics");
				} else if(item.id === 3) {
					this.$router.push("/WorkHeatMap");
				} else if(item.id === 4) {
					this.$router.push("/ToolWorkProgress");
				} else if(item.id === 5) {
					this.$router.push("/ToolWorkTrend");
				} else if(item.id === 7) {
					this.$router.push("/ToolWorkRank");
				} else if(item.id === 8) {
					this.$router.push("/HarvestStatistics");
				} else if(item.id === 9) {
					this.$router.push("/WheatHarvest");
				} else {
					this.$router.push("/WarningEquipment");
				}
			}
		}
	};
</script>
<style scoped>
	.contents {
		width: 100%;
		/* height: 100%; */
	}
	
	.content_map {
		width: 98%;
		margin: 0 auto;
		background-image: url("/static/img/nav.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}
	
	.tablist_item {
		display: flex;
	}
	
	.items {
		height: 40px;
		/* font-size: 13px; */
		font-size: 20px;
		color: #45ABF9;
		text-align: center;
		line-height: 40px;
		border-radius: 2px;
		cursor: pointer;
		margin: 0 25px;
		position: relative;
	}
	
	.tablist_item .active:nth-child(1) {
		background-image: url("/static/img/active-nav.png");
		background-size: 170% 20%;
		background-repeat: no-repeat;
		background-position: bottom;
	}
	
	.items.active {
		color: #fff;
		background-image: url("/static/img/active-nav.png");
		background-size: 100% 20%;
		background-repeat: no-repeat;
		background-position: bottom;
	}
	
	.tablist_item .hotStyle:after {
		content: '';
		display: block;
		background: url('../../../assets/img/ms/hot.png') no-repeat;
		background-size: 100% 100%;
		position: absolute;
		right: -22px;
		width: 16px;
		height: 19px;
		top: 11px;
	}
	
	.tablist_item .hotStyle2:after {
		content: '';
		display: block;
		background: url('../../../assets/img/ms/hot.png') no-repeat;
		background-size: 100% 100%;
		position: absolute;
		right: -22px;
		width: 16px;
		height: 19px;
		top: 11px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Index/view/NJNav.vue